import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import TagSearchRequest from '../../../projects/task/i-service/models/tag/request/TagSearchRequest';
import GetTagsByQueueTaskIdRequest from '../../../projects/task/i-service/models/tag/request/GetTagsByQueueTaskIdRequest';
import CreateTagRequest from '../../../projects/task/i-service/models/tag/request/CreateTagRequest';
import DeleteTagRequest from '../../../projects/task/i-service/models/tag/request/DeleteTagRequest';
import AddTagRequest from '../../../projects/task/i-service/models/tag/request/AddTagRequest';
import DeleteTagTaskRequest from '../../../projects/task/i-service/models/tag/request/DeleteTagTaskRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import TagSearchResponse from '../../../projects/task/i-service/models/tag/response/TagSearchResponse';

export default class TaskTagService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	SearchEvent = new Events<WsResponseModelT<TagSearchResponse>>();
	GetTagsByQueueTaskIdEvent = new Events<WsResponseModelT<TagSearchResponse>>();
	CreateTagAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteTagAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	AddTagTaskEvent = new Events<WsResponseModelT<Boolean>>();
	DelTagTaskAsyncEvent = new Events<WsResponseModelT<Boolean>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('TaskTagService', 'Search', 'Main', (res: WsResponseModelT<TagSearchResponse>) => {
			self.SearchEvent.trigger(res);
		});
		webApiService.on('TaskTagService', 'GetTagsByQueueTaskId', 'Main', (res: WsResponseModelT<TagSearchResponse>) => {
			self.GetTagsByQueueTaskIdEvent.trigger(res);
		});
		webApiService.on('TaskTagService', 'CreateTagAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.CreateTagAsyncEvent.trigger(res);
		});
		webApiService.on('TaskTagService', 'DeleteTagAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.DeleteTagAsyncEvent.trigger(res);
		});
		webApiService.on('TaskTagService', 'AddTagTask', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.AddTagTaskEvent.trigger(res);
		});
		webApiService.on('TaskTagService', 'DelTagTaskAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.DelTagTaskAsyncEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Поиск тегов
	 */
	async Search(model: TagSearchRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTagService',
			Method: 'Search',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка тегов по номеру очереди задач
	 */
	async GetTagsByQueueTaskId(request: GetTagsByQueueTaskIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTagService',
			Method: 'GetTagsByQueueTaskId',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание тега
	 */
	async CreateTagAsync(tag: CreateTagRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTagService',
			Method: 'CreateTagAsync',
			Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление тега
	 */
	async DeleteTagAsync(tag: DeleteTagRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTagService',
			Method: 'DeleteTagAsync',
			Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление тега к задаче
	 */
	async AddTagTask(tag: AddTagRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTagService',
			Method: 'AddTagTask',
			Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление тега из задачи
	 */
	async DelTagTaskAsync(tag: DeleteTagTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTagService',
			Method: 'DelTagTaskAsync',
			Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Поиск тегов
	 */
	async searchAsync(model: TagSearchRequest): Promise<TagSearchResponse> {
		return new Promise<TagSearchResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTagService',
				Method: 'Search',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<TagSearchResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TagSearchResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка тегов по номеру очереди задач
	 */
	async getTagsByQueueTaskIdAsync(request: GetTagsByQueueTaskIdRequest): Promise<TagSearchResponse> {
		return new Promise<TagSearchResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTagService',
				Method: 'GetTagsByQueueTaskId',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<TagSearchResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TagSearchResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание тега
	 */
	async createTagAsyncAsync(tag: CreateTagRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTagService',
				Method: 'CreateTagAsync',
				Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление тега
	 */
	async deleteTagAsyncAsync(tag: DeleteTagRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTagService',
				Method: 'DeleteTagAsync',
				Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление тега к задаче
	 */
	async addTagTaskAsync(tag: AddTagRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTagService',
				Method: 'AddTagTask',
				Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление тега из задачи
	 */
	async delTagTaskAsyncAsync(tag: DeleteTagTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTagService',
				Method: 'DelTagTaskAsync',
				Value: typeof(tag) === 'object' ? JSON.stringify(tag) : tag,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}